import { Injectable } from '@angular/core';
import { Settings } from '../models/settings.model';

@Injectable()
export class SettingsService {
    private readonly storageKey = 'settings';
    private settings: Settings;

    constructor() {
        this.settings = JSON.parse(localStorage.getItem(this.storageKey)) || new Settings();
    }

    get lastInvitationTimestamp(): number {
        return this.settings.lastInvitationTimestamp;
    }

    set lastInvitationTimestamp(value: number) {
       this.settings.lastInvitationTimestamp = value;
       this.save();
    }

    private save(): void {
        localStorage.setItem(this.storageKey, JSON.stringify(this.settings));
    }
}
